module.exports = __webpack_public_path__ + "static/media/mexico.9b1a2011.svg";